(() => {
  const script = document.currentScript;
  const pageType = script?.dataset?.pageType || '';
  const productId = script?.dataset?.productId || '';
  const productVendor = script?.dataset?.productVendor || '';
  const productTitle = script?.dataset?.productTitle || '';
  const productOnSale = script?.dataset?.productOnSale === 'true';

  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim();

  const buildStyleNavigation = (featured) => {
    if (!featured || document.querySelector('.gs-style-nav')) return;

    const categories = [
      { title: 'Neuheiten', kicker: 'Frisch eingetroffen', link: '/collections/neuheiten', image: 'https://cdn.shopify.com/s/files/1/0794/1567/3110/files/30008659-3719_101.webp?v=1788350825' },
      { title: 'Oberteile', kicker: 'Von clean bis besonders', link: '/collections/oberteile-neu', image: 'https://cdn.shopify.com/s/files/1/0794/1567/3110/files/P1092892.png' },
      { title: 'Hosen', kicker: 'Deine neue Lieblingspassform', link: '/collections/hosen-1', image: 'https://cdn.shopify.com/s/files/1/0794/1567/3110/files/30175_p-2608123854-601-04.webp?v=1788275755' },
      { title: 'Schuhe', kicker: 'Für jeden Schritt', link: '/collections/schuhe', image: 'https://cdn.shopify.com/s/files/1/0794/1567/3110/files/new-zealand-boots-plateau-clog-coffee-preorder_1.jpg?v=1788266147' },
      { title: 'Schmuck', kicker: 'Kleine Details. Große Wirkung.', link: '/collections/schmuck-1', image: 'https://cdn.shopify.com/s/files/1/0794/1567/3110/files/ChatGPT_Image_25._Aug._2026_17_18_28.png?v=1787671130' }
    ];

    const section = document.createElement('section');
    section.className = 'gs-style-nav';
    section.innerHTML = `<div class="gs-style-nav__inner">
      <div class="gs-style-nav__header">
        <div><p class="gs-style-nav__eyebrow">Für dich kuratiert</p><h2 class="gs-style-nav__title">Entdecke deinen Style.</h2></div>
        <p class="gs-style-nav__intro">Statt endlos zu suchen: Starte direkt dort, wo dein nächstes Lieblingsstück wartet.</p>
      </div>
      <div class="gs-style-nav__grid">${categories.map((item) => `<a class="gs-style-tile" href="${item.link}"><img src="${item.image}" alt="${item.title}" loading="lazy"><span class="gs-style-tile__content"><span class="gs-style-tile__kicker">${item.kicker}</span><span class="gs-style-tile__title">${item.title}</span><span class="gs-style-tile__link">Entdecken</span></span></a>`).join('')}</div>
    </div>`;
    featured.insertAdjacentElement('afterend', section);
  };

  const initHome = () => {
    if (pageType !== 'index' || document.documentElement.dataset.gs2HomeReady === 'true') return;

    const heroSection = document.querySelector('.shopify-section--slideshow');
    const heroProse = heroSection?.querySelector('.slideshow__slide.is-selected .slideshow__slide-content .prose');

    if (heroProse && !heroProse.querySelector('.gs2-hero-title')) {
      heroProse.innerHTML = '';
      const kicker = document.createElement('p');
      kicker.className = 'h6';
      kicker.textContent = 'DEIN GOLDSTÜCK. DEIN STYLE.';
      const title = document.createElement('p');
      title.className = 'h1 gs2-hero-title';
      title.textContent = 'Lieblingsstücke, die bleiben.';
      const copy = document.createElement('p');
      copy.className = 'gs-hero-copy';
      copy.textContent = 'Fashion, Accessoires und besondere Fundstücke – persönlich für dich ausgewählt.';
      const buttons = document.createElement('div');
      buttons.className = 'button-group justify-center sm:justify-center';
      buttons.innerHTML = '<a class="button" href="/collections/neuheiten">Neuheiten entdecken</a><a class="button button--outline" href="/pages/marken">Unsere Marken</a>';
      heroProse.append(kicker, title, copy, buttons);
    }

    if (heroSection && !heroSection.nextElementSibling?.classList.contains('gs-home-service-strip')) {
      const strip = document.createElement('div');
      strip.className = 'gs-home-service-strip';
      strip.innerHTML = '<div>Mit Liebe in Schwabach kuratiert</div><div>Persönliche Beratung – online & im Store</div><div>Versand innerhalb Deutschlands</div>';
      heroSection.insertAdjacentElement('afterend', strip);
    }

    const featured = document.querySelector('.shopify-section--featured-collections');
    if (featured) {
      const heading = featured.querySelector('h2');
      if (heading && /NEW ARRIVALS/i.test(heading.textContent || '')) heading.textContent = 'Gerade angekommen. Schon verliebt.';
      const collectionLink = featured.querySelector('.featured-collections-carousel__item .button');
      if (collectionLink) {
        collectionLink.textContent = 'Alle Neuheiten ansehen';
        collectionLink.setAttribute('href', '/collections/neuheiten');
      }
      const stack = featured.querySelector('.section-stack');
      const header = stack?.firstElementChild;
      if (stack && header && !stack.querySelector('.gs-section-kicker')) {
        const copy = document.createElement('p');
        copy.className = 'gs-section-kicker';
        copy.textContent = 'Die neuesten Goldstücke – frisch eingetroffen und bereit für deinen Kleiderschrank.';
        header.insertAdjacentElement('afterend', copy);
      }
      buildStyleNavigation(featured);
    }

    document.querySelectorAll('.shopify-section--recently-viewed-products h2').forEach((heading) => {
      if (/zuletzt angesehen/i.test(heading.textContent || '')) heading.textContent = 'Noch im Kopf? ♡';
    });

    document.documentElement.dataset.gs2HomeReady = 'true';
  };

  const initCollections = () => {
    if (pageType !== 'collection') return;
    document.querySelectorAll('.collection-toolbar__button').forEach((button) => {
      if (/filter/i.test(normalize(button.textContent))) button.setAttribute('aria-label', 'Produkte filtern');
    });
  };

  const hideIrrelevantProductNotices = () => {
    const vendor = productVendor.toLowerCase();
    const title = productTitle.toLowerCase();
    const isStudio = vendor.includes('goldstück studio') || vendor.includes('goldstuck studio');
    const isJewelryOrSocks = /(schmuck|kette|armband|ohrring|ohrstecker|creole|ring|socke)/i.test(title) || /(escapulario|glam&glory|little jewelry stories)/i.test(productVendor);
    document.querySelectorAll('accordion-disclosure.accordion').forEach((accordion) => {
      const label = normalize(accordion.querySelector('summary')?.textContent).toLowerCase();
      if (label.includes('hinweis zur lieferzeit') && !isStudio) accordion.remove();
      if (label.includes('hinweis zu schmuck') && !(isJewelryOrSocks || productOnSale)) accordion.remove();
    });
  };

  const euro = (cents) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Number(cents || 0) / 100);
  const recommendationImage = (product) => {
    if (!product) return '';
    if (typeof product.featured_image === 'string') return product.featured_image;
    if (product.featured_image?.url) return product.featured_image.url;
    if (typeof product.images?.[0] === 'string') return product.images[0];
    if (product.images?.[0]?.url) return product.images[0].url;
    return '';
  };

  const buildCrossSell = async () => {
    if (!productId || document.querySelector('.gs-cross-sell')) return;
    try {
      const response = await fetch(`/recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=4&intent=complementary`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const data = await response.json();
      const products = Array.isArray(data?.products) ? data.products.slice(0, 4) : [];
      if (!products.length) return;
      const section = document.createElement('section');
      section.className = 'gs-cross-sell';
      const cards = products.map((product) => {
        const image = recommendationImage(product);
        const url = product.url || `/products/${product.handle}`;
        return `<a class="gs-cross-sell-card" href="${url}"><span class="gs-cross-sell-card__media">${image ? `<img src="${image}" alt="${String(product.title || '').replace(/"/g, '&quot;')}" loading="lazy">` : ''}</span><span class="gs-cross-sell-card__info"><span class="gs-cross-sell-card__name">${product.title || ''}</span><span class="gs-cross-sell-card__price">${euro(product.price)}</span><span class="gs-cross-sell-card__cta">Dazu kombinieren</span></span></a>`;
      }).join('');
      section.innerHTML = `<div class="gs-cross-sell__inner"><div class="gs-cross-sell__header"><div><p class="gs-cross-sell__eyebrow">Komplettiere deinen Look</p><h2 class="gs-cross-sell__title">Dazu passt</h2></div><p class="gs-cross-sell__copy">Ausgewählte Ergänzungen, die sich mit deinem Lieblingsstück kombinieren lassen.</p></div><div class="gs-cross-sell__grid">${cards}</div></div>`;
      const mainProduct = document.querySelector('.shopify-section--main-product');
      if (mainProduct) mainProduct.insertAdjacentElement('afterend', section);
    } catch (_) {}
  };

  const initProduct = () => {
    if (pageType !== 'product') return;
    hideIrrelevantProductNotices();
    buildCrossSell();
    document.querySelectorAll('.shopify-section--related-products h2').forEach((heading) => {
      if (/Das könnte dir auch gefallen/i.test(heading.textContent || '')) heading.textContent = 'Ähnliche Styles für dich';
      if (/ZULETZT ANGESEHEN/i.test(heading.textContent || '')) heading.textContent = 'Noch im Kopf? ♡';
    });
  };

  const init = () => { initHome(); initCollections(); initProduct(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
